import { SettingsToggleCard } from '@/components/molecules'
import { useTranslation } from 'react-i18next'

type BenchmarkingAreaSettingProps = {
    value: boolean
    onChange: (value: boolean) => void
}

export const BenchmarkingAreaSetting: React.FC<BenchmarkingAreaSettingProps> = (
    props
) => {
    const { value, onChange } = props
    const { t } = useTranslation('translations')

    return (
        <SettingsToggleCard
            checked={value}
            onChange={onChange}
            title={t('analytics.benchmarking.normalization.area.title')}
            description={t(
                'analytics.benchmarking.normalization.area.description'
            )}
        />
    )
}
